var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "view-guide" }, [
    _vm.currentIndex === 1
      ? _c("div", { staticClass: "item" }, [
          _c("img", { attrs: { src: "/images/signFlow/index.gif" } }),
          _c("img", {
            staticClass: "click",
            style: _vm.lists[_vm.currentIndex - 1],
            attrs: { src: "/images/signFlow/click.gif" },
            on: {
              click: function($event) {
                _vm.currentIndex = 2
              }
            }
          })
        ])
      : _vm.currentIndex === 2
      ? _c("div", { staticClass: "item" }, [
          _c("img", { attrs: { src: "/images/signFlow/choiceFile.gif" } }),
          _c("img", {
            staticClass: "click",
            style: _vm.lists[_vm.currentIndex - 1],
            attrs: { src: "/images/signFlow/click.gif" },
            on: {
              click: function($event) {
                _vm.currentIndex = 3
              }
            }
          })
        ])
      : _vm.currentIndex === 3
      ? _c("div", { staticClass: "item" }, [
          _c("img", { attrs: { src: "/images/signFlow/addSigner.gif" } }),
          _c("img", {
            staticClass: "click",
            style: _vm.lists[_vm.currentIndex - 1],
            attrs: { src: "/images/signFlow/click.gif" },
            on: {
              click: function($event) {
                _vm.currentIndex = 4
              }
            }
          })
        ])
      : _vm.currentIndex === 4
      ? _c("div", { staticClass: "item" }, [
          _c("img", { attrs: { src: "/images/signFlow/setSinger.gif" } }),
          _c("img", {
            staticClass: "click",
            style: _vm.lists[_vm.currentIndex - 1],
            attrs: { src: "/images/signFlow/click.gif" },
            on: {
              click: function($event) {
                _vm.currentIndex = 5
              }
            }
          })
        ])
      : _vm.currentIndex === 5
      ? _c("div", { staticClass: "item" }, [
          _c("img", { attrs: { src: "/images/signFlow/signList.gif" } }),
          _c("img", {
            staticClass: "click",
            style: _vm.lists[_vm.currentIndex - 1],
            attrs: { src: "/images/signFlow/click.gif" },
            on: {
              click: function($event) {
                _vm.currentIndex = 6
              }
            }
          })
        ])
      : _vm.currentIndex === 6
      ? _c("div", { staticClass: "item" }, [
          _c("img", { attrs: { src: "/images/signFlow/signature.gif" } }),
          _c("img", {
            staticClass: "click",
            style: _vm.lists[_vm.currentIndex - 1],
            attrs: { src: "/images/signFlow/click.gif" },
            on: {
              click: function($event) {
                _vm.currentIndex = 7
              }
            }
          })
        ])
      : _vm.currentIndex === 7
      ? _c("div", { staticClass: "item" }, [
          _c("img", { attrs: { src: "/images/signFlow/signFinish.gif" } }),
          _c("img", {
            staticClass: "click",
            style: _vm.lists[_vm.currentIndex - 1],
            attrs: { src: "/images/signFlow/click.gif" },
            on: {
              click: function($event) {
                _vm.currentIndex = 1
              }
            }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5434cde8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5434cde8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/signInfo/viewGuide.vue
// module id = BeVf
// module chunks = 222